import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import OrderProcessingService from '../../../services/OrderProcessingService';

@Component({
  selector: 'app-admin-tools',
  imports: [MatCardModule, MatButtonModule, MatIconModule, RouterLink],
  templateUrl: './admin-tools.component.html',
  styleUrls: ['./admin-tools.component.css']
})
export class AdminToolsComponent {
  constructor(private orderProcessingService: OrderProcessingService) {}

  triggerCoinGeneration() {
    // this.orderProcessingService.triggerCoinGeneration();
    this.orderProcessingService.triggerCoinGeneration().subscribe({
      next: () => console.log('Coin generation triggered successfully'),
      error: (err) => console.error('Error triggering coin generation:', err)
    });
  }

  settingsActionButtons: { text: string; icon: string; link?: string[]; action?: () => void }[] = [
    {
      text: "Kunden suchen",
      icon: "people",
      link: ['/admin/search-customers']
    },
    {
      text: "Vertriebler verwalten",
      icon: "badge",
      link: ['/admin/sales-users/manage']
    },
    {
      text: "FAQs verwalten",
      icon: "help_center",
      link: ['/admin/manage-faqs']
    },
    {
      text: "Coin-Staffelung",
      icon: "paid",
      link: ['/admin/coins/manage']
    },
    {
      text: "Kundenzugriffe verwalten",
      icon: "paid",
      link: ['/admin/customers/manage']
    },
    {
      text: "Feedback Übersicht",
      icon: "paid",
      link: ['/admin/feedback']
    },
    {
      text: "Manuelle Coingenerierung",
      icon: "build_circle",
      action: () => this.triggerCoinGeneration()
    }
  ]
}
